<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'


export default {
	page: {
		title: 'Тарифы',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout },

    data() {
		return {
			title: 'Pricing',
			items: [],
			tariff_name: '-',
			telephony: 0,
			telephony_inner: 0,
			stt: 0,
			tts: 0,
			sms: 0,
			redirect: 4,
			count: 0
		}
	},

    computed: {
		session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
		tariff_item(){
			let tariff;
            tariff = this.$store.getters['accounts/GET_ACCOUNT_TARIFF'];
			if(tariff && tariff.products){
				return {
					'name': tariff.name,
					'products': JSON.parse(tariff.products)
				}
			} else {
				return [];
			}
        },
    },

    async mounted() {
				
		let data_send = {
			'uuid' : this.session_user_item.account.uuid
		}

		await this.$store.dispatch('accounts/FETCH_ACCOUNT_TARIFF', data_send);
		
		this.tariff_name = this.tariff_item['name'];
		this.telephony = this.tariff_item['products']['telephony']['rate'];
		this.telephony_inner = this.tariff_item['products']['inner_telephony']['rate'];
		this.stt = this.tariff_item['products']['stt']['rate'];
		this.tts = this.tariff_item['products']['tts']['rate'];
		this.sms = this.tariff_item['products']['sms_send']['rate'];
		// 18.09.2026: переадресация — гудки и разговор по одной ставке; 0.9 руб. за каждую попытку перевода наружу (наша телефония)
		let rd = this.tariff_item['products']['inner_telephony_redirect_outer'];
		if (rd && rd['rate']) this.redirect = rd['rate'];
    },
}

</script>

<template>
	<Layout>
		<div class="row justify-content-center" :id="count">
			<div class="col-lg-10">
				<div class="text-center mt-4 mb-5">
					<h3 style="margin-top: 60px"><i class="feather uil uil-calculator-alt"></i> Тарифы сервиса</h3>
					<p class="text-muted">Точная стоимость зависит от сценария диалогов, а также операторов выбранных услуг</p>
				</div>
				<div class="row justify-content-center">

					<div class="col-lg-6">
						<div class="card card-pricing" style="max-width: auto !important">
							<div class="card-body p-4">
								<div class="media" style="margin-bottom: 25px">
									<div class="media-body">
									<!--
										<h5 class="mt-0 mb-2 font-size-16">Базовый</h5>
										<h2 class="mt-0 mb-2">
											от 2.5 ₽
											<span class="font-size-14">/ звонок</span>
										</h2>
									-->
										<h5 class="mt-0 mb-2 font-size-12">Текущий тариф</h5>
										<h3 class="mt-0 mb-2">
											{{ tariff_name }}
										</h3>
									</div>
									<div class="align-self-center">
										<i class="feather uil uil-phone-pause" style="font-size: 24px"></i>
									</div>
								</div>
								
								<p style="margin-bottom: 5px">Минимальная сумма пополнения — <span style="font-weight: bold">от 1000 руб.</span></p>
								<p style="margin-bottom: 5px">Посекундная тарификация уже <span style="font-weight: bold">с 1-й секунды</span></p>
								<!--<p style="margin-bottom: 20px">Стоимость звонка при средней длительности в <span style="font-weight: bold">30 секунд - от 2.5 руб.</span></p>-->
							
                                <ul
                                    class="card-pricing-features text-muted border-top pt-2 mt-2 pl-0 list-unstyled"
                                >
									<li style="font-weight: bold">В звонок входит:</li>
                                    <li style="padding-bottom: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Телефонный исходящий трафик - <span style="font-weight: bold">{{ telephony }} руб. / мин</span>
                                    </li>
									 <li style="padding-bottom: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Телефонный входящий трафик - <span style="font-weight: bold">{{ telephony_inner }} руб. / мин</span>
                                    </li>
									<li style="padding-bottom: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Переадресация на ваш телефон (гудки и разговор) - <span style="font-weight: bold">{{ redirect }} руб. / мин</span>
                                    </li>
									<li style="padding-bottom: 5px !important; padding-left: 30px" data-row="redirect_connect">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Соединение исходящего звонка и каждой попытки переадресации на внешний номер (наша телефония) - <span style="font-weight: bold">0.9 руб.</span>; перевод внутри вашей АТС — бесплатно
                                    </li>
									<li style="padding-bottom: 5px !important; padding-top: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Распознавание речи - <span style="font-weight: bold">{{ stt }} руб. / 15 сек</span>
                                    </li>
									<li style="padding-bottom: 5px !important; padding-top: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Синтез речи - <span style="font-weight: bold">{{ tts }} руб. / 1 блок до 250 символов</span>
                                    </li>
									<li style="padding-bottom: 5px !important; padding-top: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Отправка HTTP-запросов (webhook) - <span style="font-weight: bold;">бесплатно</span>
                                    </li>
									<li style="padding-bottom: 5px !important; padding-top: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Хранение записей звонков – <span style="font-weight: bold">1 год</span>
                                    </li>
									<li style="padding-bottom: 5px !important; padding-top: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Отправка e-mail сообщений - <span style="font-weight: bold">бесплатно</span>
                                    </li>
									<li style="padding-bottom: 5px !important; padding-top: 5px !important; padding-left: 30px">
                                        <i class="uil uil-check text-success font-size-15 " style="margin-left: -23px"></i>
                                        Отправка sms сообщений - <span style="font-weight: bold">{{ sms }} руб. / сообщение</span>
                                    </li>

									<li style="padding-bottom: 0px !important; padding-top: 15px !important; padding-left: 30px">
                                        <span style="font-weight: bold">Все цены указаны с учетом НДС - 5%</span>
                                    </li>

                                </ul>

								<div class="mt-5 text-center">
									<router-link
										class="btn px-sm-4"
                                        :class="'btn-primary'"
                                        :to="{ name: 'Payments.create' }"
									>
										<i class="uil uil-arrow-right "></i> Выбрать
									</router-link>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- end row -->

	</Layout>
</template>
